
export const PENDING_NEW = 'PENDING_NEW';
export const NEW = 'NEW';
export const APPROVED = 'APPROVED';
export const DECLINED = "DECLINED";
export const SUSPENDED = "SUSPENDED";
export const PENDING_UPDATE = "PENDING_UPDATE";